module.exports = __webpack_public_path__ + "media/festival.80178e01.mp4";